import { COMPONENT_NAME as SERVICEMAN_COMPONENT_NAME, IMRServicemanComponent } from './serviceman.component'

export const SERVICEMAN_MODULE_NAME = 'simax.common.serviceman'

const module = angular.module(SERVICEMAN_MODULE_NAME, [])

module.component(SERVICEMAN_COMPONENT_NAME, new IMRServicemanComponent())
